import React, { useState } from 'react';
import { connect } from 'react-redux';
import MasterComponent from '../../../components/Forms';
import ShortListedConfig from '../../../entity/HRM/pre-onboarding/shortlistedConfig';
import { Button, DatePicker, Drawer, Modal, Space, Tag, Typography } from 'antd';
import { ColumnConfig, MasterConfigs } from '../../../interfaces/entity';
import ScheduleInterviewDrawer from './tabs/Screening/drawer';
import NextRoundModal from './tabs/Screening/modal';
import FeedbackForm from './tabs/Screening/modal/feedbackForm';
import { CalendarOutlined, BookOutlined, EditOutlined, CloseOutlined } from '@ant-design/icons'
import dayjs from 'dayjs';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { putData } from '../../../actions/developer';
import { constants } from '../../../constants/common';
import CustomModal from '../../../components/custom/Modal';
import EmployeeDetails from './EmployeeDetails';
import Badge from '../../../components/Badge';

const SortlistedCandidates = ({ level }) => {
  const [scheduleInterview, setScheduleInterView] = useState(false)
  const [edit, setEdit] = useState(null)
  const [candidateDetails, setCandidateDetails] = useState(null)

  const [feedbackForm, setFeedbackForm] = useState(false)
  const [nextRound, setNextRound] = useState(false)
  const [candidateType, setCandidateType] = useState(null)
  const [data, setData] = useState(null)
  const [selected, setSelectedRow] = useState([])
  const dispatch = useDispatch();

  const [id, setId] = useState(null)

  const OverriddenConfig: MasterConfigs = {
    ...ShortListedConfig,
    api: () => ShortListedConfig.api() + '/' + level,
    tableProps: {
      rowSelection: {
        ...ShortListedConfig.rowSelection,
        onChange: (selectedRowKeys, selectedRows) => {
          setSelectedRow(selectedRows)
        },
      },
    },
    actions: [{
      actionType: 'filter',
      name: 'Filter'
    }, selected.length > 0 && { name: 'move to next', actionType: 'Add', onClick: () => onMoveToNext() }],
    getColumns: () => [
      ...ShortListedConfig.getColumns(),
      {
        title: 'Schedule Interview',
        dataIndex: '',
        key: '',
        width: 150,
        align: 'center',
        fixed: 'right',
        render: (text) => {
          if (text?.bookedSlot) {
            return <Tag color='blue' onClick={() => onSecheduleInterview(text)}>{text.bookedSlot?.date} {text.bookedSlot?.time}</Tag>;
          } else {
            return <Button type='text' onClick={() => onSecheduleInterview(text)} icon={<CalendarOutlined />} />
          }
        },
      },
      {
        title: 'Feedback Form',
        dataIndex: '',
        key: '',
        width: 150,
        align: 'center',
        fixed: 'right',
        render: (text) => {
          if (text?.feedback) {
            return <Tag color='blue' onClick={() => onFeedback(text)}>{moment(text?.feedback?.date).format('lll')}</Tag>;
          } else {
            return <Button type='text' onClick={() => onFeedback(text)} icon={<BookOutlined />}></Button >
          }
        },
      },
      level == constants.PROFILE_STATUS.SALARY_DISCUSSION && {
        title: 'Joining Date',
        key: '',
        dataIndex: '',
        width: 200,
        fixed: 'right',
        render: (text) => {
          return <Space.Compact>
            <DatePicker
              onChange={(date, dateString) => onOfferedCTC(dateString, text, 'joiningDate')}
              disabled={edit !== text._id}
              value={text.joiningDate ? dayjs(text.joiningDate) : null}
            ></DatePicker>
            {edit !== text._id && <Button icon={<EditOutlined />} type='link' onClick={() => setEdit(text._id)}></Button>}
            {edit == text._id && <Button icon={<CloseOutlined />} type='link' onClick={() => setEdit(null)}></Button>}
          </Space.Compact>
        }
      },
      level == constants.PROFILE_STATUS.SALARY_DISCUSSION && {
        title: 'Offerd CTC',
        key: '',
        dataIndex: '',
        width: 150,
        fixed: 'right',
        render: (text) => {
          return <Typography.Title level={5} editable={{
            onChange: (e) => onOfferedCTC(e, text),
          }}>{text?.offeredCTC}</Typography.Title>
        }
      },
      {
        title: 'Status',
        dataIndex: '',
        key: '',
        width: 150,
        align: 'center',
        fixed: 'right',
        render: (text) => {
          if (text?.feedback) {
            const status = text?.feedback?.approvalStatus;
            return <Badge color={constants.GET_COLOR_FOR_STATUS[status]} text={status} />
          } else {
            return <Badge color='yellow' text='Pending' />
          }
        },
      }
    ].filter(Boolean) as ColumnConfig[],
    getFormColumns: () => [
      ...ShortListedConfig.getFormColumns().map(ele => {
        if (ele.name == 'candidateType') {
          return {
            ...ele,
            selectProps: {
              onChange: (text) => {
                setCandidateType(text);
              }
            }
          }
        } else {
          if (ele.name == "experiance") {
            if (candidateType == 'Experience') {
              return ele
            } else {
              return
            }
          } else {
            return ele
          }
        }
      }).filter(Boolean),
      {
        label: 'Interview Date',
        name: 'bookedSlot.date',
        type: 'text',
        filterFiled: true,
      }
    ]
  };


  const onOfferedCTC = async (text, item, type = 'offeredCTC') => {
    let payload;
    if (type == 'offeredCTC' && text != item.offeredCTC) {
      payload = { ...payload, offeredCTC: text }
    }
    if (type == 'joiningDate' && text != item.joiningDate) {
      payload = { ...payload, joiningDate: text }
    }
    if ((text != item.offeredCTC && type == 'offeredCTC') || (text != item.joiningDate && type == 'joiningDate')) {
      const resData = await dispatch(putData(ShortListedConfig.api() + '/' + level + '/' + item._id, payload));
      if (resData) {
        onRefresh()
        setEdit(null)
      }
    }
  }

  const onRefresh = () => {
    dispatch({
      type: 'REFRESH_TABLE',
      refreshTable: true
    })
  }


  const onSecheduleInterview = (item) => {
    setId(item._id);
    setScheduleInterView(true)
  }

  const onFeedback = (item) => {
    setId(item._id);
    setFeedbackForm(true)
    setData(item)
  }


  const onMoveToNext = () => {
    setNextRound(true)
  }

  const onCloseScheduleDrawer = () => {
    setId(null);
    setScheduleInterView(false)
  }

  return <React.Fragment>
    <ScheduleInterviewDrawer id={id} isVisible={scheduleInterview} onClose={() => onCloseScheduleDrawer()} />
    <FeedbackForm data={data} id={id} isVisible={feedbackForm} onClose={() => setFeedbackForm(false)} level={level} />
    <NextRoundModal isVisible={nextRound} onClose={() => setNextRound(false)} selected={selected} level={level} />
    <MasterComponent config={OverriddenConfig} />
    <Drawer
      title="Basic Drawer"
      placement="right"
      maskClosable={false}
      closeIcon={true}
      width={'100%'}
      onClose={() => setCandidateDetails(null)}
      open={candidateDetails}
    >
      <EmployeeDetails candidate={candidateDetails} />
    </Drawer>
  </React.Fragment>
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(SortlistedCandidates);
